const reduceToObj = (array, key) =>
  array.reduce((acc, item) => {
    acc[item[key]] = item
    return acc
  }, {})

export const BADGES = [
  { name: "Spicy", icon: "icons/badges/spicy.svg" },
  { name: "Gluten free", icon: "icons/badges/gluten-free.svg" },
  { name: "Organic", icon: "icons/badges/organic.svg" },
  { name: "Special", icon: "icons/badges/special.svg" },
  { name: "Vegan", icon: "icons/badges/vegan.svg" },
  { name: "XL", icon: "icons/badges/xl.svg" }
]

export const BADGES_MAP = reduceToObj(BADGES, "name")

export const badgeCodes = function(badgeNames) {
  return badgeNames.map(name => BADGES_MAP[name])
}

export const ALLERGENS = [
  { code: 1, name: "Wheat", icon: "icons/allergy/wheat.svg" },
  { code: 2, name: "Crustaceans", icon: "icons/allergy/crustaceans.svg" },
  { code: 3, name: "Eggs", icon: "icons/allergy/eggs.svg" },
  { code: 4, name: "Fish", icon: "icons/allergy/fish.svg" },
  { code: 5, name: "Peanuts", icon: "icons/allergy/peanuts.svg" },
  { code: 6, name: "Soya", icon: "icons/allergy/soya.svg" },
  { code: 7, name: "Milk", icon: "icons/allergy/milk.svg" },
  { code: 8, name: "Nuts", icon: "icons/allergy/treenut.svg" },
  { code: 9, name: "Celery", icon: "icons/allergy/celery.svg" },
  { code: 10, name: "Mustard", icon: "icons/allergy/mustard.svg" },
  { code: 11, name: "Sesame", icon: "icons/allergy/sesame.svg" },
  { code: 12, name: "Sulphur", icon: "icons/allergy/so2.svg" },
  { code: 13, name: "Lupin", icon: "icons/allergy/lupin.svg" },
  { code: 14, name: "Molluscs", icon: "icons/allergy/molluscs.svg" }
]

export const ALLERGENS_MAP = reduceToObj(ALLERGENS, "name")

export const allergenCodes = function(
  allergenNames,
  enclosingChar = "",
  endingChar
) {
  const allergensText = allergenNames
    .map(name => ALLERGENS_MAP[name].code)
    .sort((a, b) => a - b)
    .join(", ")
  return allergensText.length > 0
    ? `${enclosingChar}${allergensText}${endingChar || enclosingChar}`
    : ""
}

export const SAMPLE_MEAL = {
  name: "Chilli con carne",
  badges: ["Gluten free", "Organic", "Special"],
  allergens: ["Milk", "Soya"],
  price: "4.2",
  imageUrl: "imgs/placeholder-16-9.png"
}
